import { faCrown } from '@fortawesome/free-solid-svg-icons';

import { Icon } from 'apps/shared/scripts/components';

import {
  headerClassName,
  headingClassName,
  iconClassName,
  mediaClassName,
  subheadingClassName,
  summaryHeaderClassName,
} from './styles';

const SummaryHeader = () => {
  return (
    <div className={summaryHeaderClassName}>
      <div className={mediaClassName}>
        <Icon className={iconClassName} fa={faCrown} />
      </div>
      <div className={headerClassName}>
        <h2 className={headingClassName}>Pro</h2>
        <h4 className={subheadingClassName}>Perfect for groups and teams</h4>
      </div>
    </div>
  );
};

SummaryHeader.displayName = 'SummaryHeader';

export default SummaryHeader;
